import React from 'react'; 
import { RadioButton } from '@progress/kendo-react-inputs';
 
const CusRadioButton = (props) => {

    const{name, onChange, leftValue,leftValueLabel,rightValueLabel, rightValue,label, checkedValue, disabled,labelDesp} = props;
    const handleChange = React.useCallback(
        (e) => {
            props.onChange(e,name);
        },
        [onChange,checkedValue]
    )
    return (
        <div className="row around-xs inputPair elementVisible">
        <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
             <div className="box text-left">{label}</div>
             <div className="box text-left aip-otp-txt">{labelDesp}</div>
         </div>
         <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <div style={{width:'40%', float:'left'}}>
                <RadioButton id={name} name={name} value={leftValue} onChange={handleChange} checked={checkedValue === leftValue} disabled={disabled}>&nbsp;{leftValueLabel}</RadioButton>
            </div>
            <div style={{width:'60%', float:'left'}}>
                <RadioButton id={name} name={name} value={rightValue} onChange={handleChange} checked={checkedValue === rightValue} disabled={disabled}>&nbsp;{rightValueLabel}</RadioButton>
            </div>
         </div> 
        </div>  
    )
}

export default CusRadioButton;